import React, { useState, useEffect } from 'react'
import Icon, { IconType } from '../../Icon'
import { VoteCountdownProps } from './../types'
import style from './VoteCountdown.module.scss'

const DURATION = 60

const getRemainingTime = (start): number =>  Math.max( Math.floor( DURATION - ( Date.now() - start) / 1000 ), 0 )

const VoteCountdown: React.FC<VoteCountdownProps> = ({ countdownStart, clearCountdown }) => {

  const [seconds, setSeconds] = useState(getRemainingTime( countdownStart ) )

  useEffect(() => {

    if (seconds > 0) {

      const interval = setInterval(() => {

        setSeconds(getRemainingTime( countdownStart ) )

      }, 1000)
      return () => clearInterval(interval)

    }
    else{

      clearCountdown()
    }


  }, [seconds])

  return <div
    className={ style['polls-alerttext-container']}
    data-bdd="polls-alerttext-container"
  >
    <Icon
      name={ IconType.iconName.infoCircle }
      colour={IconType.colour.task}
      className={ style['info-circle'] }/>
    <span>
      Keep poll open for at least {seconds}s
    </span>
  </div>

}

export default VoteCountdown
